import React, { createContext, useContext } from 'react';
import type { PropsWithChildren } from 'react';

const AppDomainContext = createContext('');

export const AppDomainProvider = ({
  appDomain,
  children,
}: PropsWithChildren<{ appDomain: string }>) => (
  <AppDomainContext.Provider value={appDomain}>{children}</AppDomainContext.Provider>
);

export const useAppDomain = () => useContext(AppDomainContext);
